<template>
<div>

  <section class="content">

      <!-- Default box -->
      <div class="box box-primary">
        <div class="box-header with-border">
          <h3 class="box-title">Ledger List</h3>
          <span class="float-right">
            <button v-if="canAccess('ledger-create')" type="button" class="btn btn-xs btn-success" @click="newModal"><i class="fa fa-plus"></i></button>
          </span>

          <div class="box-tools pull-right">
            <button type="button" class="btn btn-box-tool" data-widget="collapse" data-toggle="tooltip" title="" data-original-title="Collapse">
              <i class="fa fa-minus"></i></button>
            <button type="button" class="btn btn-box-tool" data-widget="remove" data-toggle="tooltip" title="" data-original-title="Remove">
              <i class="fa fa-times"></i></button>
          </div>
        </div>
        <div class="box-body">
          
          <vue-good-table
                :columns="columns"
                :rows="rows"
                styleClass="vgt-table condensed"
                :pagination-options="{
                  enabled: true,
                  perPage: 10,
                  perPageDropdown: [10, 20, 30],
                }"
                :search-options="{
                  enabled: true,
                  trigger: 'enter',
                }"
              >
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field == 'Status'">
                    <span v-if="props.row.status == 'active'" class="label label-success" >Active</span>
                    <span v-else class="label label-danger">InActive</span>
                  </span>
                  <span v-if="props.column.field == 'id'">
                    <span v-if="props.row.systemEntry != 'true'">
                      <button v-if="canAccess('ledger-update')" type="button" @click="editModal(props.row)" class="btn btn-success btn-sm">
                        <i class="fa fa-pencil"></i>
                      </button>
                    </span>
                  </span>
                  <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>
                </template>
              </vue-good-table>
                
        </div>
        <!-- /.box-body -->
        <div class="box-footer">
          List of all Ledger
        </div>
        <!-- /.box-footer-->
      </div>
      <!-- /.box -->

  </section>
  
      <div class="modal fade" id="newModal">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 v-show="!editMode" class="modal-title">Add New</h4>
              <h4 v-show="editMode" class="modal-title">Update</h4>
            </div>
            <form @submit.prevent="editMode ? updateLedger() : createLedger()">
              <div class="modal-body">
                <!-- right column -->
                  <div class="card card-warning">
                    <!-- /.card-header -->
                    <div class="card-body">
                      <div class="row">
                        <div class="col-sm-6">
                          <!-- text input -->
                          <div class="form-group">
                            <label>Ledger <span class="red">*</span></label>
                            <input v-model="form.name" type="text" name="name" class="form-control" :class="{ 'is-invalid': form.errors.has('name') }" />
                            <has-error :form="form" field="name"></has-error>
                          </div>
                          <div class="form-group">
                            <label>Alias <span class="red">*</span></label>
                            <input v-model="form.alias" type="text" name="alias" class="form-control" :class="{ 'is-invalid': form.errors.has('alias') }" />
                            <has-error :form="form" field="alias"></has-error>
                          </div>

                        </div>
                        <div class="col-sm-6">
                          <div class="form-group">
                            <label>Group <span class="red">*</span></label>
                            <select v-model="form.group_id" name="group_id" class="form-control" :class="{'is-invalid': form.errors.has('group_id')}">
                              <option v-if="!form.group_id" selected value="">Select Group</option>
                              <option v-for="(group,index) in groups" :key="index" :value="group.id">{{group.group}}</option>
                            </select>
                            <has-error :form="form" field="group_id"></has-error>
                          </div>
                          <!-- <div class="form-group">
                            <label>OpeningBalance <span class="red">*</span></label>
                            <input v-model="form.openingBalance" type="hidden" name="openingBalance" class="form-control" :class="{ 'is-invalid': form.errors.has('openingBalance') }" />
                            <has-error :form="form" field="openingBalance"></has-error>
                          </div> -->
                          <div class="form-group">
                            <label>Select Status <span class="red">*</span></label>
                            <select v-model="form.status" name="status" class="form-control" :class="{'is-invalid': form.errors.has('status')}">
                              <option v-if="!form.status" selected value="">Select Status</option>
                              <option value="active">Active</option>
                              <option value="inActive">Inactive</option>
                            </select>
                            <has-error :form="form" field="status"></has-error>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                
              </div>
              <div class="modal-footer text-center">
                <button v-show="!editMode" type="submit" class="btn btn-success" > CREATE </button>
                <button v-show="editMode" type="submit" class="btn btn-success"> UPDATE </button>
                <button type="button" class="btn btn-danger" data-dismiss="modal" > CANCEL</button>
              </div>
            </form>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
      
</div>
</template>

<script>
export default {
  name: 'Group',
  data () {
    return {
      editMode: false,
      form: new Form({
        id: '',
        name: '',
        alias: '',
        group_id: '',
        group: '',
        openingBalance: 0,
        status: ''
      }),
      columns: [
        {
          label: 'Name',
          field: 'name'
        },
        {
          label: 'Alias',
          field: 'alias'
        },
        {
          label: 'Group',
          field: 'group.group'
        },
        // {
        //   label: 'OpeningBalance',
        //   field: 'openingBalance'
        // },
        {
          label: 'STATUS',
          field: 'Status'
        },
        {
          label: 'ACTIONS',
          field: 'id',
          type: 'number'
        }
      ],
      rows: [],
      groups: []
    }
  },
  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    newModal () {
      this.editMode = false
      this.form.reset()
      $('#newModal').modal({backdrop: 'static', keyboard: false})
    },

    createLedger () {
      this.$axios
        .post('ledger', this.form, {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then(() => {
          Fire.$emit('AfterCreate')
          $('#newModal').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Ledger Added Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },

    editModal (row) {
      this.editMode = true
      this.form.reset()
      $('#newModal').modal({backdrop: 'static', keyboard: false})
      this.form.fill(row)
    },
    updateLedger () {
      this.$axios
        .put('ledger/' + this.form.id, this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          Fire.$emit('AfterCreate')
          $('#newModal').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Ledger Details Updated Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    loadData () {
      this.$axios
        .get('ledger?all=all', {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then((response) => response.data)
        .then((data) => {
          this.rows = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
      this.$axios
        .get('group?all=all', {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then((response) => response.data)
        .then((data) => {
          this.groups = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },

  created () {
    this.loadData()
    Fire.$on('AfterCreate', () => {
      this.loadData()
    })
  }
}
</script>



// WEBPACK FOOTER //
// Ledger.vue?798ff3e1